import axios from "axios"
import { API_URL } from "./constants"
import { toast, Slide } from 'react-toastify';

export function apiGet(endpoint, data = {}) {
    const finalEndpoint = finalUrl(endpoint);
    return apiRequest(finalEndpoint, data, "get", {});
}

export function apiPost(endpoint, data) {
    const finalEndpoint = finalUrl(endpoint);
    return apiRequest(finalEndpoint, data, "post", {});
}

export function apiPut(endpoint, data) {
    const finalEndpoint = finalUrl(endpoint);
    return apiRequest(finalEndpoint, data, "put", {});
}

export function apiDelete(endpoint /* , data, header */) {
    /*   const user = getObject("user");
      console.log(data, "wokring")
      const headers = { ...header, Authorization: user.token }; */
    const finalEndpoint = finalUrl(endpoint);
    return apiRequest(finalEndpoint, {}, "delete", {});
}

export function apiPatch(endpoint, data) {
    const finalEndpoint = finalUrl(endpoint);
    return apiRequest(finalEndpoint, data, "patch", {});
}

export function getHeaders() {
    const auth = getObject("auth") || {};
    if (auth) {
        return {
            Authorization: auth
        };
    }
    return {};
}

export function apiRequest(endPoint, data, method, headers) {
    return new Promise((resolve, reject) => {
        headers = {
            ...getHeaders(),
            ...headers
        };

        if (method === "get" || method === "delete") {
            data = {
                params: data,
                // paramsSerializer: function (params) {
                //   return queryString.stringify(params, { arrayFormat: "repeat" });
                // },
                headers
            };
        }
        axios[method](endPoint, data, { headers })
            .then(response => {
                const { data } = response;
                if (data.status === 200) {
                    return resolve(data);
                }
                else if (data.status === 0) {
                    removeAuthObjects()
                    setTimeout(() => {
                        window.open('https://admin.fronicmedia.com/login', "_self")
                    }, 500)
                    return
                }
                return reject(data);
            })
            .catch(error => {
                return reject(error);
            });
    });
}

const finalUrl = slug => {
    return API_URL + slug;
};

export const saveObject = (key, data) => {
    let obj = JSON.stringify(data);
    localStorage.setItem(key, obj);
};

export const removeObject = key => {
    localStorage.removeItem(key);
};

export const getObject = key => {
    return JSON.parse(localStorage.getItem(key));
};

export const validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const isLoggedIn = () => {
    let auth = getObject("auth");
    if (auth) {
        return true;
    }
    return false;
};

export function toastSuccess(message, time = 3000) {
    toast.success(message, {
        autoClose: time,
        hideProgressBar: true,
        position: "bottom-right",
        transition: Slide,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    })
    clearWaitingQueue()
}

export function toastError(message, time = 3000) {
    toast.error(message || 'Something went wrong.', {
        autoClose: time,
        hideProgressBar: true,
        position: "bottom-right",
        transition: Slide,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    })
    clearWaitingQueue()
}

export function clearWaitingQueue() {
    toast.clearWaitingQueue();
}

export function removeAuthObjects() {
    removeObject('auth')
}

// Encryption key for user details session
const USER_DETAILS_ENCRYPTION_KEY = 'FronicUserDetails2024SecretKey!@#';

// Simple encryption using base64 and XOR (lightweight obfuscation)
export const encryptData = (data) => {
  try {
    const jsonStr = JSON.stringify(data);
    const encrypted = btoa(
      jsonStr.split('').map((char, i) =>
        String.fromCharCode(char.charCodeAt(0) ^ USER_DETAILS_ENCRYPTION_KEY.charCodeAt(i % USER_DETAILS_ENCRYPTION_KEY.length))
      ).join('')
    );
    return encrypted;
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

// Simple decryption using base64 and XOR
export const decryptData = (encryptedData) => {
  try {
    const decrypted = atob(encryptedData)
      .split('')
      .map((char, i) =>
        String.fromCharCode(char.charCodeAt(0) ^ USER_DETAILS_ENCRYPTION_KEY.charCodeAt(i % USER_DETAILS_ENCRYPTION_KEY.length))
      )
      .join('');
    return JSON.parse(decrypted);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

// Check if protected routes session is valid (within 2 hours)
// Used by both /user_details and /payout routes for synchronized access
export const checkUserDetailsSession = () => {
  try {
    const authData = getObject('userDetailsAuth');
    if (!authData || !authData.timestamp) {
      return false;
    }

    const decryptedTimestamp = decryptData(authData.timestamp);
    if (!decryptedTimestamp) {
      return false;
    }

    const currentTime = Date.now();
    const sessionAge = currentTime - decryptedTimestamp;
    const TWO_HOURS = 7200000; // 2 hours in milliseconds

    return sessionAge < TWO_HOURS;
  } catch (error) {
    console.error('Session validation error:', error);
    return false;
  }
};

// Set protected routes session with encrypted timestamp
// Shared by both /user_details and /payout routes
export const setUserDetailsSession = (timestamp) => {
  try {
    const encryptedTimestamp = encryptData(timestamp);
    const encryptedAuth = encryptData(true);

    if (encryptedTimestamp && encryptedAuth) {
      saveObject('userDetailsAuth', {
        timestamp: encryptedTimestamp,
        authenticated: encryptedAuth
      });
      return true;
    }
    return false;
  } catch (error) {
    console.error('Session save error:', error);
    return false;
  }
};

// Clear protected routes session
// Clears session for both /user_details and /payout routes
export const clearUserDetailsSession = () => {
  removeObject('userDetailsAuth');
};

// Decode JWT token payload
export const getTokenPayload = () => {
  try {
    const token = getObject('auth');
    if (!token) return null;
    const base64Payload = token.split('.')[1];
    const payload = JSON.parse(atob(base64Payload));
    return payload;
  } catch (error) {
    console.error('Token decode error:', error);
    return null;
  }
};

// Check if user has access to label requests
export const hasLabelRequestAccess = () => {
  const payload = getTokenPayload();
  return payload?.accessToLabelRequest === 'yes';
};